<template>
  <div class="sidebar-card" id="other_sim_widget">
    <h3>Mes autres numéros</h3>
    <div>
      <div v-if="$store.state.core.subscriber == null">
        <b-skeleton width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
      </div>
      <div v-if="$store.state.core.subscriber != null">
        <div
          @click="toggle_sim_details_sidebar(phone_number)"
          class="other-sim-line"
          v-if="
            phone_number.msisdn != $store.state.core.subscriber.infos.msisdn
          "
          v-for="(phone_number, index) in $store.state.core.subscriber.numbers
            .others"
          :key="index"
        >
          <i class="kgk-mtn-sim-card"></i>

          <div>
            <span>{{ crop_prefix(phone_number.msisdn) }}</span>
            <span class="text-muted"
              >Enregistré le {{ phone_number.creation_date }}</span
            >
          </div>

          <i class="mdi mdi-arrow-right momo-color"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "OtherSimWidget",
  data: function () {
    return {};
  },
  mounted: async function () {},
  methods: {},
};
</script>
<style  lang="css">
#other_sim_widget {
}
</style>
